import React, { Component } from 'react';
import { NumericFormat } from 'react-number-format';
import colores from '../../../css/bootstrap.scss'
import '../../../css/ingresos.css';
import toast, { Toaster } from 'react-hot-toast';
import { MyContext } from '../../../context/AuthContext';
import { Modal } from 'react-bootstrap';
import { MoonLoader } from 'react-spinners';

class RepartoUtilidades extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            tiposrepartoutilidades: [],
            cuentas: [],
            sucursales: [],
            listaRepartoUtilidades: [],
            registroPrevio: false,
            repartoRegistro: {
                idTipoRepartoUtilidades: '',
                nombreTipoRepartoUtilidades: '',
                idCuenta: '',
                nombreCuenta: '',
                monto: '',
                idSucursal: '',
                nombreSucursal: '',
                descripcion: ''
            },
            idTipoRepartoUtilidadesEditar: '',
            idCuentaEditar: '',
            idSucursalEditar: '',
            descripcionEditar: '',
            showModalEditar: false,
            dataCorte: []
         }
    }
    
    static contextType = MyContext;
   
    componentDidMount = async () => {
        this.context.cambiarSubruta('Reparto Utilidades');
        window.addEventListener('resize', this.getHeightWindow);
        window.addEventListener('beforeunload', this.alertUser);
        this.getHeightWindow();
        await this.selectTiposRepartoUtilidades();
        await this.selectCuentas();
        await this.selectSucursales();
        this.comprobrarRegistros();
        this.selectDatosCorte();
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.fecha !== this.props.fecha) {
            if (this.context.rootState.saved) { 
                this.setState({
                    loading: true
                });
                this.componentDidMount();
            }else{
                if (window.confirm('¿Continuar sin guardar cambios?')) {     
                    this.setState({
                        loading: true
                    });   
                    this.componentDidMount();
                }
            }
        }
    }

    alertUser = (e) => {
        if (this.context.rootState.saved === false) {   
            e.preventDefault();
            e.returnValue = '';   
        }
    }

    getHeightWindow = () => {
        var height = window.innerHeight;
        if (document.getElementsByClassName("contenedorSecundario")[0]) {
            document.getElementsByClassName("contenedorSecundario")[0].style.height = (height - 230) + 'px';
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    selectTiposRepartoUtilidades = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/tiposrepartoutilidades.php', requestOptions);
        const data = await response.json();
        data.tiposrepartoutilidades.forEach((_, index) => {
            data.tiposrepartoutilidades[index].monto = '';
        });
        this.setState({
            tiposrepartoutilidades: data.tiposrepartoutilidades
        })
    }
    
    selectCuentas = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/cuentas.php', requestOptions);
        const data = await response.json();
        data.cuentas.forEach((_, index) => {
            data.cuentas[index].monto = '';
        });
        this.setState({
            cuentas: data.cuentas
        })
    }

    selectSucursales = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'select', empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/sucursales.php', requestOptions);
        const data = await response.json();
        data.sucursales.forEach((_, index) => {
            data.sucursales[index].monto = '';
        });
        if (data.sucursales.length === 1) { 
            this.setState({
                sucursales: data.sucursales,
                repartoRegistro: {
                    idTipoRepartoUtilidades: '',
                    nombreTipoRepartoUtilidades: '',
                    idCuenta: '',
                    nombreCuenta: '',
                    monto: '',
                    idSucursal: 1,
                    nombreSucursal: data.sucursales[0].nombre,
                    descripcion: ''
                },
            })
        }else{
            this.setState({
                sucursales: data.sucursales,
            })
        }
    }

    comprobrarRegistros = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'comprobar', fecha: this.props.fecha, empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/repartoutilidades.php', requestOptions);
        const data = await response.json();
        if (data.error === 0) {
            if (data.mensaje !== false) {
                toast.success('Registro encontrado.');
                data.listaRepartoUtilidades.forEach(element => {  
                    if (element.idCuenta !== 'efectivo') {
                        element.nombreCuenta = this.state.cuentas.find(e => e.idCuenta === element.idCuenta).nombre;
                    }else{
                        element.nombreCuenta = 'Efectivo del Día';
                    }
                    element.nombreTipoRepartoUtilidades = this.state.tiposrepartoutilidades.find(e => e.idTipoRepartoUtilidades === element.idTipoRepartoUtilidades).nombre;
                    element.nombreSucursal = this.state.sucursales.find(e => e.idSucursal === element.idSucursal).nombre;
                });
                this.setState({
                    listaRepartoUtilidades: data.listaRepartoUtilidades,
                    registroPrevio: true,
                    loading: false
                })
            }else{
                this.setState({
                    registroPrevio: false,
                    listaRepartoUtilidades: [],
                    efectivo: '',
                    loading: false
                })
                this.selectTiposRepartoUtilidades();
                this.selectCuentas();
                this.selectSucursales();
            }
        }else{
            toast.error('Error al consultar registros.');
        }
    }
    
    onChangeMonto = (value) => {
        this.setState({
            ...this.state,
            repartoRegistro: {
                ...this.state.repartoRegistro,
                monto: value
            }
        })
    }

    onChangeProducto = (e) => {
        let nombreTipoRepartoUtilidades = '';
        if (e.target.value) {       
            nombreTipoRepartoUtilidades = this.state.tiposrepartoutilidades.find((element) => element.idTipoRepartoUtilidades === e.target.value).nombre;   
        }
        this.setState({
            ...this.state,
            repartoRegistro: {
                ...this.state.repartoRegistro,
                idTipoRepartoUtilidades: e.target.value,
                nombreTipoRepartoUtilidades: nombreTipoRepartoUtilidades
            }
        })
    }
    
    onChangeCuenta = (e) => {
        let nombreCuenta = '';
        if (e.target.value) {   
            if (e.target.value !== 'efectivo') {
                nombreCuenta = this.state.cuentas.find((element) => element.idCuenta === e.target.value).nombre;  
            }else{
                nombreCuenta = 'Efectivo del Día';
            }
        }
        this.setState({
            ...this.state,
            repartoRegistro: {
                ...this.state.repartoRegistro,
                idCuenta: e.target.value,
                nombreCuenta: nombreCuenta
            }
        })
    }

    onChangeSucursal = (e) => {
        let nombreSucursal = '';
        if (e.target.value) {       
            nombreSucursal = this.state.sucursales.find((element) => element.idSucursal === e.target.value).nombre;   
        }
        this.setState({
            ...this.state,
            repartoRegistro: {
                ...this.state.repartoRegistro,
                idSucursal: e.target.value,
                nombreSucursal: nombreSucursal
            }
        })
    }

    onChangeDescripcion = (e) => {
        this.setState({
            ...this.state,
            repartoRegistro: {
                ...this.state.repartoRegistro,
                descripcion: e.target.value,
            }
        })
    }

    agregarCostoVentaLista = () => {
        toast.remove();
        if (this.state.repartoRegistro.idTipoRepartoUtilidades && this.state.repartoRegistro.monto && this.state.repartoRegistro.idCuenta && this.state.repartoRegistro.idSucursal) {
            if (this.state.listaRepartoUtilidades.find(element => (element.idTipoRepartoUtilidades === this.state.repartoRegistro.idTipoRepartoUtilidades) && (element.idCuenta === this.state.repartoRegistro.idCuenta) && (element.idSucursal === this.state.repartoRegistro.idSucursal) && (element.descripcion === this.state.repartoRegistro.descripcion))) {
                let montoPrevio = this.state.listaRepartoUtilidades.find(element => (element.idTipoRepartoUtilidades === this.state.repartoRegistro.idTipoRepartoUtilidades) && (element.idCuenta === this.state.repartoRegistro.idCuenta) && (element.idSucursal === this.state.repartoRegistro.idSucursal) && (element.descripcion === this.state.repartoRegistro.descripcion)).monto;
                let listaRepartoUtilidades = this.state.listaRepartoUtilidades;
                let indexProducto = this.state.listaRepartoUtilidades.findIndex(element => (element.idTipoRepartoUtilidades === this.state.repartoRegistro.idTipoRepartoUtilidades) && (element.idCuenta === this.state.repartoRegistro.idCuenta) && (element.idSucursal === this.state.repartoRegistro.idSucursal) && (element.descripcion === this.state.repartoRegistro.descripcion));
                listaRepartoUtilidades[indexProducto].monto = Number(montoPrevio) + Number(this.state.repartoRegistro.monto);
                if (this.state.sucursales.length === 1) {
                    this.setState({
                        listaRepartoUtilidades: listaRepartoUtilidades,
                        repartoRegistro: {
                            idTipoRepartoUtilidades: '',
                            nombreTipoRepartoUtilidades: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: 1,
                            nombreSucursal: this.state.sucursales[0].nombre,
                            descripcion: ''
                        }
                    });                    
                }else{
                    this.setState({
                        listaRepartoUtilidades: listaRepartoUtilidades,
                        repartoRegistro: {
                            idTipoRepartoUtilidades: '',
                            nombreTipoRepartoUtilidades: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: '',
                            nombreSucursal: '',
                            descripcion: ''
                        }
                    });
                }
                toast.success('Reparto sumado en la lista');    
            }else{
                if (this.state.sucursales.length === 1) {                    
                    this.setState(prevState => ({
                        listaRepartoUtilidades: [...prevState.listaRepartoUtilidades,  this.state.repartoRegistro],
                        repartoRegistro: {
                            idTipoRepartoUtilidades: '',
                            nombreTipoRepartoUtilidades: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: 1,
                            nombreSucursal: this.state.sucursales[0].nombre,
                            descripcion: ''
                        }
                    }));
                }else{
                    this.setState(prevState => ({
                        listaRepartoUtilidades: [...prevState.listaRepartoUtilidades,  this.state.repartoRegistro],
                        repartoRegistro: {
                            idTipoRepartoUtilidades: '',
                            nombreTipoRepartoUtilidades: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: '',
                            nombreSucursal: '',
                            descripcion: ''
                        }
                    }));
                }
                toast.success('Reparto de utilidades agregado a lista');
            }
            this.context.unsaveChanges();
        }else{
            toast.error('Llene los campos solicitados');
        }
    }

    editarCostoVentaLista = async () => {
        toast.remove();
        if (this.state.repartoRegistro.idTipoRepartoUtilidades && this.state.repartoRegistro.monto && this.state.repartoRegistro.idCuenta && this.state.repartoRegistro.idSucursal) {
            let filteredArray = this.state.listaRepartoUtilidades.filter(element => !((element.idTipoRepartoUtilidades === this.state.idTipoRepartoUtilidadesEditar) && (element.idCuenta === this.state.idCuentaEditar) && (element.idSucursal === this.state.idSucursalEditar) && (element.descripcion === this.state.descripcionEditar)));
            await this.setState({
                listaRepartoUtilidades: filteredArray
            });
            this.context.unsaveChanges();
            this.agregarCostoVentaLista();
            this.hideModalEditar();
        }else{
            toast.error('Llene los campos solicitados');
        }
    }

    quitarCostoVentaLista = (idTipoRepartoUtilidades, idCuenta, idSucursal, descripcion) => {
        toast.remove();
        if (window.confirm('¿Quitar reparto de la lista?')) {
            let filteredArray = this.state.listaRepartoUtilidades.filter(element => !((element.idTipoRepartoUtilidades === idTipoRepartoUtilidades) && (element.idCuenta === idCuenta) && (element.idSucursal === idSucursal) && (element.descripcion === descripcion)));
            this.setState({
                listaRepartoUtilidades: filteredArray
            });
            this.context.unsaveChanges();
        }
    }

    getTotal = () => {
        let total = 0;
        let listaRepartoUtilidades = this.state.listaRepartoUtilidades;
        listaRepartoUtilidades.forEach((producto) => {
            total= total += Number(producto.monto)
        });
        return total
    }

    limpiar = () => {
        if (this.state.listaRepartoUtilidades.length !== 0) {
            if (window.confirm('¿Quitar todos los repartos de utilidades de la lista?')) {
                if (this.state.sucursales.length === 1) {
                    this.setState({
                        listaRepartoUtilidades: [],
                        repartoRegistro: {
                            idTipoRepartoUtilidades: '',
                            nombreTipoRepartoUtilidades: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: 1,
                            nombreSucursal: this.state.sucursales[0].nombre,
                            descripcion: ''
                        }
                    })                
                }else{                
                    this.setState({
                        listaRepartoUtilidades: [],
                        repartoRegistro: {
                            idTipoRepartoUtilidades: '',
                            nombreTipoRepartoUtilidades: '',
                            idCuenta: '',
                            nombreCuenta: '',
                            monto: '',
                            idSucursal: '',
                            nombreSucursal: '',
                            descripcion: ''
                        }
                    }) 
                }
                this.context.unsaveChanges();
            }
        }
    }

    showModalEditar = (idTipoRepartoUtilidades, idCuenta, idSucursal, descripcion) => {
        let ingresoLista = this.state.listaRepartoUtilidades.find(element => (element.idTipoRepartoUtilidades === idTipoRepartoUtilidades) && (element.idCuenta === idCuenta) && (element.idSucursal === idSucursal) && (element.descripcion === descripcion));
        this.setState({
            repartoRegistro: {
                idTipoRepartoUtilidades: ingresoLista.idTipoRepartoUtilidades,
                nombreTipoRepartoUtilidades: ingresoLista.nombreTipoRepartoUtilidades,
                idCuenta: ingresoLista.idCuenta,
                nombreCuenta: ingresoLista.nombreCuenta,
                monto: ingresoLista.monto,
                idSucursal: ingresoLista.idSucursal,
                nombreSucursal: ingresoLista.nombreSucursal,
                descripcion: ingresoLista.descripcion
            },
            showModalEditar: true,
            idTipoRepartoUtilidadesEditar: idTipoRepartoUtilidades,
            idCuentaEditar: idCuenta,
            idSucursalEditar: idSucursal,
            descripcionEditar: descripcion
        });
    }

    hideModalEditar = () => {
        if (this.state.sucursales.length === 1) {                
            this.setState({
                repartoRegistro: {
                    idTipoRepartoUtilidades: '',
                    nombreTipoRepartoUtilidades: '',
                    idCuenta: '',
                    nombreCuenta: '',
                    monto: '',
                    idSucursal: 1,
                    nombreSucursal: this.state.sucursales[0].nombre,
                    descripcion: ''
                },
                showModalEditar: false,
                idTipoRepartoUtilidadesEditar: '',
                idCuentaEditar: '',
                idSucursalEditar: '',
                descripcionEditar: ''
            })
        }else{                
            this.setState({
                repartoRegistro: {
                    idTipoRepartoUtilidades: '',
                    nombreTipoRepartoUtilidades: '',
                    idCuenta: '',
                    nombreCuenta: '',
                    monto: '',
                    idSucursal: '',
                    nombreSucursal: '',
                    descripcion: ''
                },
                showModalEditar: false,
                idTipoRepartoUtilidadesEditar: '',
                idCuentaEditar: '',
                idSucursalEditar: '',
                descripcionEditar: ''
            })
        }
    }

    selectDatosCorte = async () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectDatosDia', fecha: this.props.fecha, empresa: this.context.rootState.nombre })
        };
        const response = await fetch('http://pruebas.argeos.net/php/DB/cortes.php', requestOptions);
        const data = await response.json();
        if (data.error === 0) {
            this.setState({
                dataCorte: data
            })
        }else{
            toast.error('Error al obtener datos de corte.');
        }
    }

    registrar = async () => {
        if (this.getTotal() !== 0) {
            this.deleteCorte();
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ operacion: 'insert', listaRepartoUtilidades: this.state.listaRepartoUtilidades, fecha: this.props.fecha, empresa: this.context.rootState.nombre })
            };
            const response = await fetch('http://pruebas.argeos.net/php/DB/repartoutilidades.php', requestOptions);
            const data = await response.json();
            if (data.error === 0) {
                toast.success(data.mensaje);
                this.reloadHeader();
                this.setState({
                    registroPrevio: true
                });
                this.context.saveChanges();
            }else{
                toast.error('Error al registrar repartos de utilidades.');
                console.log(data.mensaje);
            }
        }else{
            toast.error('No puede registrar un total de $0.');
        }
    }

    editar = async () => {
        if (this.getTotal() !== 0) {
            this.deleteCorte();
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ operacion: 'update', listaRepartoUtilidades: this.state.listaRepartoUtilidades, fecha: this.props.fecha, empresa: this.context.rootState.nombre })
            };
            const response = await fetch('http://pruebas.argeos.net/php/DB/repartoutilidades.php', requestOptions);
            const data = await response.json();
            if (data.error === 0) {
                toast.success(data.mensaje);
                this.reloadHeader();
                this.setState({
                    registroPrevio: true
                });
                this.context.saveChanges();
            }else{
                toast.error('Error al actualizar repartos de utilidades.');
                console.log(data.mensaje);
            }
        }else{
            if (window.confirm('¿Borrar repartos de utilidades?')) {
                this.deleteCorte();
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ operacion: 'delete', fecha: this.props.fecha, empresa: this.context.rootState.nombre })
                };
                const response = await fetch('http://pruebas.argeos.net/php/DB/repartoutilidades.php', requestOptions);
                const data = await response.json();
                if (data.error === 0) {
                    toast.success(data.mensaje);
                    this.reloadHeader();
                    this.setState({
                        registroPrevio: false
                    });
                    this.context.saveChanges();
                }else{
                    toast.error('Error al borrar repartos de utilidades.');
                    console.log(data.mensaje);
                }
            }
        }
    }

    deleteCorte = async () => {
        if (this.props.estatusCorte) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ operacion: 'deleteCorte', fecha: this.props.fecha, cuentas: this.state.dataCorte.cuentas, empresa: this.context.rootState.nombre })
            };
            const response = await fetch('http://pruebas.argeos.net/php/DB/cortes.php', requestOptions);
            const data = await response.json();
            if (data.error !== 0) { 
                toast.error('Error al borrar corte previo.');
                console.log(data.mensaje);
            }
        }
    }

    reloadHeader = () => {
        document.getElementById('btnHeaderReload').click();
    }

    render() { 
            return ( 
            <>
                <div className="contenedorSecundario bg-light" style={{ overflowY: 'auto' }}>
                    <div className="row w-100 m-0">
                        <div className="col-12">
                            <div className="elemento py-2">
                                <div className="row">
                                    <div className="col-7">
                                        <label>Tipo reparto de utilidades</label>
                                        <select className='form-control' name="idTipoRepartoUtilidades" value={this.state.repartoRegistro.idTipoRepartoUtilidades} onChange={this.onChangeProducto}>
                                            <option value="">Seleccionar</option>
                                            {
                                                this.state.tiposrepartoutilidades.map((e, index) =>
                                                    <option key={index} value={e.idTipoRepartoUtilidades}>{e.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>                                  
                                    <div className="col-5">
                                        <label>Monto</label>
                                        <div className="input-group">
                                            <span className='input-group-text'>$</span>
                                            <NumericFormat thousandSeparator=',' className='form-control text-end' required value={this.state.repartoRegistro.monto} defaultValue={''} placeholder='0.0' onValueChange={(values) => this.onChangeMonto(Number(values.value))}/>
                                        </div>
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label>Pagado con</label>
                                        <select className='form-control' name="idCuenta" value={this.state.repartoRegistro.idCuenta} onChange={this.onChangeCuenta}>
                                            <option value="">Seleccionar</option>
                                            <option value="efectivo">Efectivo del Día</option>
                                            {
                                                this.state.cuentas.map((e, index) =>
                                                    <option key={index} value={e.idCuenta}>{e.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label>Sucursal</label>
                                        <select className='form-control' name="idSucursal" value={this.state.repartoRegistro.idSucursal} onChange={this.onChangeSucursal} disabled={this.state.sucursales.length === 1}>
                                            <option value="">Seleccionar</option>
                                            {
                                                this.state.sucursales.map((e, index) =>
                                                    <option key={index} value={e.idSucursal} hidden={e.cerrado}>{e.nombre}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                    <div className="col-12 mt-2">
                                        <label>Descripción</label>
                                        <input type="text" className='form-control' name='descripcion' style={{ color: 'black' }} value={this.state.repartoRegistro.descripcion} onChange={this.onChangeDescripcion}/>
                                    </div>
                                    <div className="col-12 mt-2 d-flex align-items-end justify-content-center">
                                        <button className='btn btn-info btnRadius px-4' style={{ color: 'white' }} onClick={this.agregarCostoVentaLista}>Agregar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.listaRepartoUtilidades[0] ?
                                this.state.listaRepartoUtilidades.map((e, index) =>
                                    <div className="col-12 mt-3" key={index}>
                                        <div className="elemento py-1">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="row">
                                                        <div className="col-12 d-flex">
                                                            <p className='m-0' style={{ fontSize: '12px' }}>{e.nombreSucursal + ' ->'}</p><p className='m-0 ms-1' style={{ fontSize: '12px' }}>{e.nombreTipoRepartoUtilidades}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='m-0' style={{ fontSize: '10px' }}><i className="bi bi-credit-card"></i> {e.nombreCuenta}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className='m-0' style={{ fontSize: '10px' }}>{e.descripcion}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4" style={{ borderLeft: '1px solid #e0e0e0' }}>
                                                    <div className="row" style={{ borderBottom: '1px solid #e0e0e0' }}>
                                                        <div className="col-12 text-end">
                                                            <p className='m-0' style={{ fontSize: '14px' }}>$ {this.numberWithCommas(e.monto)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-6 p-0 text-center">
                                                            <button className='btn btn-sm btn-outline-secondary me-1 ms-auto py-0 px-2 w-75' style={{ height: '20px' }} onClick={() => this.showModalEditar(e.idTipoRepartoUtilidades, e.idCuenta, e.idSucursal, e.descripcion)}>
                                                                <i className="bi bi-pen" style={{ color: colores.secondary, fontSize: '12px' }}></i>
                                                            </button>
                                                        </div>
                                                        <div className="col-6 p-0 text-center">
                                                            <button className='btn btn-sm btn-outline-danger ms-1 me-auto py-0 px-2 w-75' style={{ height: '20px' }} onClick={() => this.quitarCostoVentaLista(e.idTipoRepartoUtilidades, e.idCuenta, e.idSucursal, e.descripcion)}>
                                                                <i className="bi bi-trash" style={{ color: colores.danger, fontSize: '12px' }}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            :
                                <div className="col-12 mt-3">
                                    <div className="elemento text-center">
                                        <p className='m-0'>Agregue elementos a la lista</p>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                <div className="contenedorSecundarioTotal bg-white">
                    <div className="row m-0 h-100">
                        <div className="col-6" style={{ borderRight: '1px solid ' + colores.light, color: 'black', paddingBlock: '10px' }}>
                            Total Reparto Utilidades:
                        </div>
                        <div className="col-6 text-end" style={{ color: 'black', paddingBlock: '10px' }}>
                            $ {this.numberWithCommas(this.getTotal())}
                        </div>
                        <div className="col-12 text-center d-flex align-items-center py-2 justify-content-center" style={{ borderTop: '1px solid ' + colores.light }}>
                            <button className='btn btn-lg btn-primary btnRadius mx-3' style={{ width: '40%', color: 'white' }} onClick={this.limpiar}>Limpiar</button>
                            {
                                this.state.registroPrevio ?
                                    <button className='btn btn-lg btn-secondary text-white btnRadius mx-3' style={{ width: '40%' }} onClick={this.editar}>Editar</button>
                                :
                                    <button className='btn btn-lg btn-secondary text-white btnRadius mx-3' style={{ width: '40%' }} onClick={this.registrar}>Registrar</button>
                            }
                        </div>
                    </div>
                </div>                
                <Modal show={this.state.showModalEditar} onHide={this.hideModalEditar} centered>
                    <Modal.Header className='degradado'>                        
                        <h5 style={{ color: 'white' }} className='m-0'>Editar Reparto de Utilidades</h5>
                    </Modal.Header>
                    <Modal.Body>     
                        <div className="row">
                            <div className="col-7">
                                <label>Tipo reparto de utilidades</label>
                                <select className='form-control' name="idTipoRepartoUtilidades" style={{ color: 'black' }} value={this.state.repartoRegistro.idTipoRepartoUtilidades} onChange={this.onChangeProducto}>
                                    <option value="">Seleccionar</option>
                                    {
                                        this.state.tiposrepartoutilidades.map((e, index) =>
                                            <option key={index} value={e.idTipoRepartoUtilidades}>{e.nombre}</option>
                                        )
                                    }
                                </select>
                            </div>                                  
                            <div className="col-5">
                                <label>Monto</label>
                                <div className="input-group">
                                    <span className='input-group-text'>$</span>
                                    <NumericFormat thousandSeparator=',' className='form-control text-end' style={{ color: 'black' }} required value={this.state.repartoRegistro.monto} defaultValue={''} placeholder='0.0' onValueChange={(values) => this.onChangeMonto(Number(values.value))}/>
                                </div>
                            </div>
                            <div className="col-6 mt-2">
                                <label>Pagado con</label>
                                <select className='form-control' name="idCuenta"style={{ color: 'black' }} value={this.state.repartoRegistro.idCuenta} onChange={this.onChangeCuenta}>
                                    <option value="">Seleccionar</option>
                                    <option value="efectivo">Efectivo del Día</option>
                                    {
                                        this.state.cuentas.map((e, index) =>
                                            <option key={index} value={e.idCuenta}>{e.nombre}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="col-6 mt-2">
                                <label>Sucursal</label>
                                <select className='form-control' name="idSucursal" style={{ color: 'black' }} value={this.state.repartoRegistro.idSucursal} onChange={this.onChangeSucursal} disabled={this.state.sucursales.length === 1}>
                                    <option value="">Seleccionar</option>
                                    {
                                        this.state.sucursales.map((e, index) =>
                                            <option key={index} value={e.idSucursal} hidden={e.cerrado}>{e.nombre}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="col-12 mt-2">
                                <label>Descripción</label>
                                <input type="text" className='form-control' name='descripcion' style={{ color: 'black' }} value={this.state.repartoRegistro.descripcion} onChange={this.onChangeDescripcion}/>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='btn btnRadius btn-primary text-white mx-3' style={{ width: '30%' }} type='button' onClick={this.hideModalEditar}>Cancelar</button>
                        <button className='btn btnRadius btn-secondary mx-3' style={{ width: '30%', color: 'white' }} type='button' onClick={this.editarCostoVentaLista}>Editar</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.loading} centered size='sm' className='modalCargando'>
                    <Modal.Body className='ms-auto me-auto'>
                        <MoonLoader color={'#ffffff'} loading={true} size={100} />
                    </Modal.Body>
                </Modal>
                <Toaster/>
            </>
                )
    }
}
 
export default RepartoUtilidades;